module.exports = __webpack_public_path__ + "assets/img/186301.5142e452.png";